import {
    Box,
    Card,
    Grid,
    InputAdornment,
    InputLabel,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import React from 'react';
import {
    NumberOfDoorsArray,
    NumberOfSeatsArray,
    yearArray,
} from '../Boat/NumberArray';

import AcUnitIcon from '@mui/icons-material/AcUnit';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import AirlineSeatLegroomExtraIcon from '@mui/icons-material/AirlineSeatLegroomExtra';
import AirlineSeatLegroomReducedIcon from '@mui/icons-material/AirlineSeatLegroomReduced';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import EdgesensorHighIcon from '@mui/icons-material/EdgesensorHigh';
import KeyOffIcon from '@mui/icons-material/KeyOff';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import NavigationIcon from '@mui/icons-material/Navigation';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import SpeedIcon from '@mui/icons-material/Speed';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import TireRepairIcon from '@mui/icons-material/TireRepair';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import carData from './car_makes_and_models.json';
import bikeData from './bike_makes_and_models.json';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import FormAutocomplete from '../../../../shared/FormAutocomplete';
import FormTextField from '../../../../shared/FormTextField';
import { useFormState } from '../../Form/useFormState';
import { CalendarMonth } from '@mui/icons-material';

type VehicleData = {
    [key: string]: string[];
};

const carDataTyped: VehicleData = carData;
const bikeDataTyped: VehicleData = bikeData;

export const bodyTypes = [
    { value: 'bus', label: 'Bus' },
    { value: 'cabChassis', label: 'Cab Chassis' },
    { value: 'convertible', label: 'Convertible' },
    { value: 'coupe', label: 'Coupe' },
    { value: 'fastback', label: 'Fastback' },
    { value: 'hatchback', label: 'Hatchback' },
    { value: 'lightTruck', label: 'Light Truck' },
    { value: 'limousine', label: 'Limousine' },
    { value: 'minivan', label: 'Minivan' },
    { value: 'sedan', label: 'Sedan' },
    { value: 'sportsCar', label: 'Sports Car' },
    { value: 'stationWagon', label: 'Station Wagon' },
    { value: 'suv', label: 'SUV' },
    { value: 'ute', label: 'Ute' },
    { value: 'van', label: 'Van' },
];

export const fuelTypes = [
    { value: 'petrol', label: 'Petrol' },
    { value: 'diesel', label: 'Diesel' },
    { value: 'electric', label: 'Electric' },
    { value: 'hybrid', label: 'Hybrid' },
    { value: 'cng', label: 'CNG' },
    { value: 'lpg', label: 'LPG' },
];
export const carTransmissionTypes = [
    { value: 'manual', label: 'Manual' },
    { value: 'automatic', label: 'Automatic' },
    { value: 'cvt', label: 'CVT' },
];
export const motorBikeTransmissionTypes = [
    { value: 'manual', label: 'Manual' },
    { value: 'automatic', label: 'Automatic' },
    { value: 'electric', label: 'Electric' },
];

export default function NewVehicleAmenitiesForm() {
    const { experience } = useFormState();
    const subType = experience.details.subType;

    const theme = useTheme();

    const { control, setValue } = useFormContext();

    const make = useWatch({ control, name: 'details.make' });

    const carItems = [
        {
            name: 'rearVisionCamera',
            selected: false,
            icon: <ControlCameraIcon fontSize='large' />,
        },
        {
            name: 'cruiseControl',
            selected: false,
            icon: <SpeedIcon fontSize='large' />,
        },
        {
            name: 'touchscreenDisplay',
            selected: false,
            icon: <TouchAppIcon fontSize='large' />,
        },
        {
            name: 'bluetooth',
            selected: false,
            icon: <BluetoothIcon fontSize='large' />,
        },
        {
            name: 'heatedSeats',
            selected: false,
            icon: <DeviceThermostatIcon fontSize='large' />,
        },
        {
            name: 'androidAuto',
            selected: false,
            icon: <AndroidIcon fontSize='large' />,
        },
        {
            name: 'appleCarPlay',
            selected: false,
            icon: <AppleIcon fontSize='large' />,
        },
        {
            name: 'blindSpotAlert',
            selected: false,
            icon: <CrisisAlertIcon fontSize='large' />,
        },
        {
            name: 'navigation',
            selected: false,
            icon: <NavigationIcon fontSize='large' />,
        },
        {
            name: 'tyrePressureSensor',
            selected: false,
            icon: <TireRepairIcon fontSize='large' />,
        },
        {
            name: 'airbags',
            selected: false,
            icon: <AirlineSeatReclineNormalIcon fontSize='large' />,
        },
        {
            name: 'ac',
            selected: false,
            icon: <AcUnitIcon fontSize='large' />,
        },
        {
            name: 'keylessEntry',
            selected: false,
            icon: <KeyOffIcon fontSize='large' />,
        },
        {
            name: 'sunroof',
            selected: false,
            icon: <WbSunnyIcon fontSize='large' />,
        },
        {
            name: 'laneAssist',
            selected: false,
            icon: <AddRoadIcon fontSize='large' />,
        },
        {
            name: 'autoPark',
            selected: false,
            icon: <LocalParkingIcon fontSize='large' />,
        },
        {
            name: 'powerSeats',
            selected: false,
            icon: <AirlineSeatLegroomReducedIcon fontSize='large' />,
        },
        {
            name: 'remoteStart',
            selected: false,
            icon: <SettingsRemoteIcon fontSize='large' />,
        },
        {
            name: 'wirelessPhoneCharger',
            selected: false,
            icon: <EdgesensorHighIcon fontSize='large' />,
        },
        {
            name: 'rearEntertainmentSystem',
            selected: false,
            icon: <LiveTvIcon fontSize='large' />,
        },
    ];

    const motorBikeItems = [
        {
            name: 'rearVisionCamera',
            selected: false,
            icon: <ControlCameraIcon fontSize='large' />,
        },
        {
            name: 'heatedSeats',
            selected: false,
            icon: <DeviceThermostatIcon fontSize='large' />,
        },
        {
            name: 'androidAuto',
            selected: false,
            icon: <AndroidIcon fontSize='large' />,
        },
        {
            name: 'appleCarPlay',
            selected: false,
            icon: <AppleIcon fontSize='large' />,
        },
        {
            name: 'cruiseControl',
            selected: false,
            icon: <SpeedIcon fontSize='large' />,
        },
        {
            name: 'touchscreenDisplay',
            selected: false,
            icon: <TouchAppIcon fontSize='large' />,
        },
        {
            name: 'bluetooth',
            selected: false,
            icon: <BluetoothIcon fontSize='large' />,
        },
        {
            name: 'blindSpotAlert',
            selected: false,
            icon: <CrisisAlertIcon fontSize='large' />,
        },
        {
            name: 'navigation',
            selected: false,
            icon: <NavigationIcon fontSize='large' />,
        },
        {
            name: 'tyrePressureSensor',
            selected: false,
            icon: <TireRepairIcon fontSize='large' />,
        },
        {
            name: 'airbags',
            selected: false,
            icon: <AirlineSeatReclineNormalIcon fontSize='large' />,
        },
        {
            name: 'adjustableSeats',
            selected: false,
            icon: <AirlineSeatLegroomExtraIcon fontSize='large' />,
        },
        {
            name: 'helmet',
            selected: false,
            icon: <SportsMotorsportsIcon fontSize='large' />,
        },
        {
            name: 'gloves',
            selected: false,
            icon: <SportsMmaIcon fontSize='large' />,
        },
    ];

    const makeNames =
        subType === 'car'
            ? Object.keys(carData).map((make) => ({
                  value: make,
                  label: make,
              }))
            : Object.keys(bikeData).map((make) => ({
                  value: make,
                  label: make,
              }));

    const modelNames =
        subType === 'car'
            ? (carDataTyped[make] || []).map((model) => ({
                  value: model,
                  label: model,
              }))
            : (bikeDataTyped[make] || []).map((model) => ({
                  value: model,
                  label: model,
              }));

    const handleMakeChange = () => {
        setValue('details.model', '');
        setValue('details.year', '');
        setValue('details.transmission', '');
        setValue('details.fuelType', '');
        if (subType === 'car') {
            setValue('details.bodyType', '');
            setValue('details.numberOfDoors', '');
            setValue('details.numberOfSeats', '');
        } else {
            setValue('details.engineCC', '');
        }
    };

    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography variant='h2' component='legend'>
                        Experience Amenities
                    </Typography>
                    <Typography color='text.secondary' gutterBottom>
                        Tell guests what your {subType} has to offer
                    </Typography>
                </div>
                <div>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <InputLabel htmlFor='make__input'>Make</InputLabel>
                            <FormAutocomplete
                                id='make__input'
                                name='details.make'
                                control={control}
                                options={makeNames}
                                disabled={!subType}
                                onOptionSelect={handleMakeChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputLabel htmlFor='model__input'>
                                Model
                            </InputLabel>
                            <FormAutocomplete
                                id='model__input'
                                name='details.model'
                                control={control}
                                options={modelNames}
                                disabled={!make}
                                placeholder={make ? '' : 'Select Vehicle Make'}
                            />
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <InputLabel htmlFor='year__input'>
                        Year (optional)
                    </InputLabel>
                    <FormAutocomplete
                        id='year__input'
                        name='details.year'
                        control={control}
                        options={yearArray}
                        disableClearable={undefined}
                        startAdornment={
                            <InputAdornment position='start'>
                                <CalendarMonth
                                    fontSize='small'
                                    color='disabled'
                                />
                            </InputAdornment>
                        }
                    />
                </div>
                {subType === 'car' ? (
                    <div>
                        <InputLabel htmlFor='body-type__input'>
                            Body Type
                        </InputLabel>
                        <FormAutocomplete
                            id='body-type__input'
                            name='details.bodyType'
                            control={control}
                            options={bodyTypes}
                        />
                    </div>
                ) : (
                    <div>
                        <InputLabel htmlFor='engine-cc__input'>
                            Engine CC
                        </InputLabel>
                        <FormTextField
                            id='engine-cc__input'
                            name='details.engineCC'
                            control={control}
                            type='number'
                            placeholder='450'
                        />
                    </div>
                )}
                <div>
                    <InputLabel htmlFor='transmission__input'>
                        Transmission
                    </InputLabel>
                    <FormAutocomplete
                        id='transmission__input'
                        name='details.transmission'
                        control={control}
                        options={
                            subType === 'car'
                                ? carTransmissionTypes
                                : motorBikeTransmissionTypes
                        }
                    />
                </div>
                <div>
                    <InputLabel htmlFor='fuel-type__input'>
                        Fuel Type
                    </InputLabel>
                    <FormAutocomplete
                        id='fuel-type__input'
                        name='details.fuelType'
                        control={control}
                        options={fuelTypes}
                    />
                </div>
                {subType === 'car' && (
                    <div>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <InputLabel htmlFor='number-of-doors__input'>
                                    No. Doors
                                </InputLabel>
                                <FormAutocomplete
                                    id='number-of-doors__input'
                                    name='details.numberOfDoors'
                                    options={NumberOfDoorsArray}
                                    control={control}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputLabel htmlFor='number-of-seats__input'>
                                    No. Seats
                                </InputLabel>
                                <FormAutocomplete
                                    id='number-of-seats__input'
                                    name='details.numberOfSeats'
                                    control={control}
                                    options={NumberOfSeatsArray}
                                />
                            </Grid>
                        </Grid>
                    </div>
                )}
                <Typography id='experience-features-select'>
                    Select available features:
                </Typography>
                <div>
                    <Grid
                        container
                        columns={{ lg: 5, md: 4, xs: 2 }}
                        spacing={2}
                        aria-labelledby='experience-features-select'
                    >
                        {(subType === 'car' ? carItems : motorBikeItems).map(
                            (item, i) => (
                                <Grid item xs={1} key={i}>
                                    <Controller
                                        name={`details.${item.name}`}
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <Card
                                                sx={{
                                                    height: '100px',
                                                    bgcolor: value
                                                        ? 'primary.main'
                                                        : theme.palette.neutral
                                                              .main,
                                                    color: value
                                                        ? 'primary.contrastText'
                                                        : 'text.primary',
                                                }}
                                                onClick={() =>
                                                    setValue(
                                                        `details.${item.name}`,
                                                        !value,
                                                        { shouldDirty: true },
                                                    )
                                                }
                                            >
                                                <Box
                                                    display='flex'
                                                    flexDirection='column'
                                                    alignItems='center'
                                                    height='100%'
                                                    gap={1}
                                                    justifyContent='center'
                                                    textAlign='center'
                                                >
                                                    {item.icon}
                                                    <Typography
                                                        sx={{
                                                            bgcolor: value
                                                                ? theme.palette
                                                                      .primary
                                                                      .main
                                                                : theme.palette
                                                                      .neutral
                                                                      .main,
                                                            color: value
                                                                ? theme.palette
                                                                      .primary
                                                                      .contrastText
                                                                : theme.palette
                                                                      .text
                                                                      .primary,
                                                        }}
                                                    >
                                                        {item.name ===
                                                        'rearVisionCamera'
                                                            ? 'Rear Camera'
                                                            : item.name ===
                                                                'cruiseControl'
                                                              ? 'Cruise Control'
                                                              : item.name ===
                                                                  'touchscreenDisplay'
                                                                ? 'Touch Screen'
                                                                : item.name ===
                                                                    'heatedSeats'
                                                                  ? 'Heated Seats'
                                                                  : item.name ===
                                                                      'androidAuto'
                                                                    ? 'Android Auto'
                                                                    : item.name ===
                                                                        'appleCarPlay'
                                                                      ? 'Apple CarPlay'
                                                                      : item.name ===
                                                                          'blindSpotAlert'
                                                                        ? 'Blindspot Alert'
                                                                        : item.name ===
                                                                            'tyrePressureSensor'
                                                                          ? 'Tyre Pressure Sensor'
                                                                          : item.name ===
                                                                              'ac'
                                                                            ? 'Air Conditioning'
                                                                            : item.name ===
                                                                                'keylessEntry'
                                                                              ? 'Keyless Entry'
                                                                              : item.name ===
                                                                                  'laneAssist'
                                                                                ? 'Lane Assist'
                                                                                : item.name ===
                                                                                    'powerSeats'
                                                                                  ? 'Power Seats'
                                                                                  : item.name ===
                                                                                      'remoteStart'
                                                                                    ? 'Remote Start'
                                                                                    : item.name ===
                                                                                        'wirelessPhoneCharger'
                                                                                      ? 'Wireless Phone Charger'
                                                                                      : item.name ===
                                                                                          'rearEntertainmentSystem'
                                                                                        ? 'Rear Entertainment System'
                                                                                        : item.name ===
                                                                                            'adjustableSeats'
                                                                                          ? 'Adjustable Seats'
                                                                                          : item.name
                                                                                                .charAt(
                                                                                                    0,
                                                                                                )
                                                                                                .toUpperCase() +
                                                                                            item.name.slice(
                                                                                                1,
                                                                                            )}
                                                    </Typography>
                                                </Box>
                                            </Card>
                                        )}
                                    />
                                </Grid>
                            ),
                        )}
                    </Grid>
                </div>
            </Stack>
        </fieldset>
    );
}
